import { render, staticRenderFns } from "./AnimatedBurger.vue?vue&type=template&id=0c3252ce&scoped=true&"
import script from "./AnimatedBurger.vue?vue&type=script&lang=ts&"
export * from "./AnimatedBurger.vue?vue&type=script&lang=ts&"
import style0 from "./AnimatedBurger.vue?vue&type=style&index=0&id=0c3252ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3252ce",
  null
  
)

export default component.exports